<template>
  <div class="room-waiting-table-component">
    <div class="room-waiting-table-wrapper">
      <table class="room-waiting-table table-fixed">
        <colgroup>
          <col width="5%">
          <col width="10%">
          <col width="10%">
          <col width="5%">
          <col width="5%">
          <col width="8%">
          <col width="8%">
        </colgroup>
        <thead>
          <tr>
            <th class="align-center">{{ $t("common.number") }}</th>
            <th>{{ $t("common.name") }}</th>
            <th>{{ $t("waitingRoom.join.time") }}</th>
            <th class="align-center">{{ $t("common.device.camera") }}</th>
            <th class="align-center">{{ $t("common.device.mic") }}</th>
            <th class="align-center">{{ $t("setting.join.role.title") }}</th>
            <th class="align-center">{{ $t("deviceSetting.preview.join.request") }}</th>
          </tr>
        </thead>
      </table>
    </div>
    <perfect-scrollbar>
      <div class="room-waiting-table-wrapper body">
        <table class="room-waiting-table table-fixed">
          <colgroup>
            <col width="5%">
            <col width="10%">
            <col width="10%">
            <col width="5%">
            <col width="5%">
            <col width="8%">
            <col width="8%">
          </colgroup>
          <tbody>
            <tr v-for="(waiting, i) in waitingList" :key="i">
              <td class="align-center truncate">{{ i + 1 }}</td>
              <td class="truncate">{{ waiting.nickName }}</td>
              <td class="truncate">{{ dayjs(waiting.joinDate).format('YYYY-MM-DD HH:mm:ss') }}</td>
              <td class="align-center truncate" :class="[waiting.cameraStatus === 'on' ? 'success' : 'error']">{{ waiting.cameraStatus === 'on' ? $t('common.normal') : $t('common.error') }}</td>
              <td class="align-center truncate" :class="[waiting.micStatus === 'on' ? 'success' : 'error']">{{ waiting.micStatus === 'on' ?  $t('common.normal') : $t('common.error') }}</td>
              <td class="align-center truncate">
                <!-- @input=""-->
                <GrmSelect maxContent white :options="userRoleOptions" @input="(roleId) => changeUserRole(waiting, roleId)" />
              </td>
              <td class="align-center">
                <div class="room-waiting-button-container">
                  <VButton small
                           @click="approveApi({roomId: room.roomId, userId:waiting.userId, roleId: waiting.joinRoleId})"
                  >{{ $t("common.apply") }}</VButton>
                  <VButton small
                           cancel
                           @click="
                             $alert({
                               text: $t('waitingRoom.confirm.disapprove', { '0': waiting.nickName }),
                               ok: () => {
                                 disapproveApi({roomId: room.roomId, userId:waiting.userId, roleId: waiting.joinRoleId})
                               }
                             })
                           "
                  >{{ $t("common.reject") }}</VButton>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </perfect-scrollbar>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import dayjs from "dayjs";

import {roomEventApi} from '@/core/api/room.event.api'

import VButton from '@/components/Common/VButton'
import GrmSelect from '@/components/Common/select/GrmSelect.vue'

export default {
  name: 'RoomWaitingTable',
  components: {
    VButton,
    GrmSelect
  },
  data() {
    const events = {
      waiting_room_approved: e => {
        this.APPROVAL(e.data.userId);
        if(this.waitingList.length <= 0) {
          this.SET_UNCHECKED(false)
        }
      },
      waiting_room_disapproved: e => {
        this.APPROVAL(e.data.userId);
        if(this.waitingList.length <= 0) {
          this.SET_UNCHECKED(false)
        }
      },
      waiting_room_left: e => {
        this.APPROVAL(e.userId);
        if(this.waitingList.length <= 0) {
          this.SET_UNCHECKED(false)
        }
      },
      waiting_room_noDevicePermission: e => {
        if (this.userId === e.userId) { // XXX 서버에서 대상을 찾아서 보내면 더 좋다.
          this.NO_PERMISSION();
        }
      },
      waiting_room_joined: e => {
        const user = { ...e.data.user, joinRoleId: this.defaultRoleId }

        this.ADD_WAITING_USER(user);
        if(!this.$isModalShown('RoomWaitingModal')) {
          this.SET_UNCHECKED(true)
        }
      },
      waiting_room_disabled: e => {
        console.log('waiting_room_disabled')
      },
    }
    return {
      events,
      defaultRoleId: 'participant'
    }
  },
  mounted() {
    roomEventApi.addEventListeners(this.events, this);
  },
  beforeMount() {
    roomEventApi.removeEventListeners(this.events);
  },
  computed: {
    userRoleOptions() {
      return [
        {
          value: 'emcee',
          title: this.$t('common.emcee')
        },
        {
          value: 'participant',
          title: this.$t('common.participant'),
          selected: true
        },
      ]
    },
    ...mapGetters('room', [ 'room',]),
    ...mapState('waitingRoom',
        ['waitingList', 'enterRequested', 'approved', 'disapproved', 'noPermission', 'noManagerInRoom', 'roomClosed',]),
  },
  methods: {
    dayjs,
    ...mapActions('waitingRoom',
        ['findAllByRoomIdApi', 'approveApi', 'disapproveApi', 'requestEnterApi',
         'disableWaitingRoomApi', 'leaveWaitingRoomApi', 'sendTestNoManagerInRoomApi', 'sendTestCloseRoomApi']),
    ...mapMutations('waitingRoom', [
      'CHANGE_ROLE_ID', 'ENTER_REQUESTED', 'ADD_WAITING_USER', 'APPROVAL', 'APPROVED', 'SET_UNCHECKED',
      'DISAPPROVED', 'NO_PERMISSION', 'NO_MANAGER_IN_ROOM', 'ROOM_CLOSED',
    ]),
    changeUserRole(user, roleId) {
      this.CHANGE_ROLE_ID({userId: user.userId, roleId})
    }
  },
  watch: {
    approved(val) {
      if (val) {
        console.log(val)
      }
    },
    disapproved(val) {
      if (val) {
        console.log(val)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.room-waiting-table-component {
}

.room-waiting-table-wrapper {
  &.body {
    height: 360px;
    background: rgba(0, 0, 0, 0.02);
  }
}

.room-waiting-table {
  font-size: 13px;
  text-align: left;

  thead {
    height: 32px;
    background-color: #f2f4f7;
  }

  tbody {
    tr {
      height: 46px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      background-color: #fff;
      transition: 0.1s ease-out;

      &:nth-of-type(2n) {
        background-color: rgba(0, 0, 0, 0.01);
      }

      &:hover {
        background-color: #f2f4f7;
      }
    }
  }

  th {
    padding: 0 10px;
    font-size: 12px;
    color: #999;
  }

  td {
    padding: 0 10px;
    color: #333;

    &.gray {
      color: #999;
    }

    &.bold {
      font-weight: 700;
    }

    &.me {
      color: $mainColor;
    }

    &.success {
      color: $mainColor;
    }

    &.error {
      color: #f05;
    }
  }

  th, td {
    &.align-center {
      text-align: center;
    }
  }
}

.room-waiting-button-container {
  display: flex;
  align-self: center;
  gap: 0 4px;
}

// component
.v-button-component {
  flex: 1;
}
</style>